import { render } from "./ChannelTrending.vue?vue&type=template&id=0ca1c020&scoped=true"
import script from "./ChannelTrending.vue?vue&type=script&lang=js"
export * from "./ChannelTrending.vue?vue&type=script&lang=js"

import "./ChannelTrending.vue?vue&type=style&index=0&id=0ca1c020&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca1c020"]])

export default __exports__